module.exports = __webpack_public_path__ + "static/media/Resume-Xun.55648ece.pdf";